<template>
  <div>
    <!-- 需关注的老人 -->
    <div class="bjThing mt10" v-if="home_moon_follow_data">
      <div class="bjLeft heightAuto pb20" style="width:100%;">
        <div class="b_comTopCont">
          <div class="dayNum">最近30天</div>
          <div class="dayName">|</div>
          <div class="dayName">需要关注的长者</div>
          <div class="countRed" v-if="home_moon_follow_data.totleCount != 0">{{ home_moon_follow_data.totleCount }}位</div>
          <div class="count" v-if="home_moon_follow_data.totleCount == 0">{{ home_moon_follow_data.totleCount }}位</div>
          <div class="seeTh" @click="cli_see_gzOld_list_moon(1)" v-if="home_moon_follow_data.totleCount != 0">查看全部</div>
        </div>

        <!-- 有数据情况 -->
        <div class="bjContWrap bjContWrap_moon" v-if="home_moon_follow_data.resultFlag">
          <div class="oldState">
            <!-- 一个 -->
            <div class="o_table border_no" v-if="home_moon_follow_data.digitalTwinFollowCountList.length == 1">
              <div class="o_tableList border_4444" :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                <div class="o_name">{{ item2.content }}</div>
                <div class="o_num">{{ item2.count }}位</div>
              </div>
            </div>
            <!-- 两个 -->
            <div class="o_table border_no" v-if="home_moon_follow_data.digitalTwinFollowCountList.length == 2">
              <div class="o_tableList" :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                <div class="o_name">{{ item2.content }}</div>
                <div class="o_num">{{ item2.count }}位</div>
              </div>
            </div>
            <!-- 三个或四个 -->
            <div class="o_table border_no o_table_Three" style="margin-top: 50px;" v-if="home_moon_follow_data.digitalTwinFollowCountList.length > 2 && home_moon_follow_data.digitalTwinFollowCountList.length < 5">
              <div class="o_tableList" :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                <div class="o_name">{{ item2.content }}</div>
                <div class="o_num">{{ item2.count }}位</div>
              </div>
            </div>
            <!-- 五个或六个 -->
            <div class="o_table border_no o_table_Three" style="height: 262px;margin-top:3px;" v-if="home_moon_follow_data.digitalTwinFollowCountList.length > 4">
              <div :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                <div class="o_tableList" v-if="index2 < 5">
                  <div class="o_name">{{ item2.content }}</div>
                  <div class="o_num">{{ item2.count }}位</div>
                </div>
                <div class="o_tableList" v-if="index2 == 5">
                  <div class="o_name">...</div>
                  <div class="o_num">&nbsp;</div>
                </div>
              </div>
            </div>
            

            <div class="oRightWrap ml25">
              <el-carousel height="270px" :interval="50000" arrow="never" :loop="false" indicator-position='none'  ref="lb_moonFollow" @change="change_lb_follow">
                <el-carousel-item :key="index" v-for="(item,index) in home_moon_follow_data.newList" >
                  <div class="oRightWrap" style="height: 270px;">
                    <div class="oRightList" :key="index2" v-for="(item2,index2) in item">
                      <div class="o_topBox">
                        <img class="peoIconImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                        <div class="oName">{{item2.buAndFlName}}</div>
                      </div>
                      <div class="flex mt10">
                        <div class="varSta">
                          <img class="tanhaoIcon" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                          <div>{{item2.contentList[0]}}</div>
                        </div>
                        <div class="exceIcon" v-if="item2.contentList.length > 2">
                          <div class="threePoint">...</div>
                        </div>
                      </div>
                      <div class="flex mt10" v-if="item2.contentList[1]">
                        <div class="varSta">
                          <img class="tanhaoIcon" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                          <div>{{item2.contentList[1]}}</div>
                        </div>
                      </div>
                      <div class="btnSee" @click="open_tan_needGz_portrait(item2)">查看</div>
                    </div>
                  </div>
                  
                </el-carousel-item>
              </el-carousel>
              <div v-if="home_moon_follow_data.newList && home_moon_follow_data.newList.length > 1">
                <img class="backIcon backIcon_left" src="../../../assets/backIconLeft.png" alt="" @click="arrowClick_follow(1,'needGz')" v-if="home_moon_follow_lbPage != 1">
                <img class="backIcon backIcon_left" src="../../../assets/backIconLeft2.png" alt="" @click="arrowClick_follow(1,'needGz')" v-if="home_moon_follow_lbPage == 1">
                <img class="backIcon backIcon_right" src="../../../assets/backIconRight.png" alt="" @click="arrowClick_follow(2,'needGz')" v-if="home_moon_follow_lbPage != home_moon_follow_data.newList.length">
                <img class="backIcon backIcon_right" src="../../../assets/backIconRight2.png" alt="" @click="arrowClick_follow(2,'needGz')" v-if="home_moon_follow_lbPage == home_moon_follow_data.newList.length">
              </div>

            </div>
          </div>
        </div>
        
        <!-- 无数据情况 -->
        <div class="noData" style="height:257px;" v-if="!home_moon_follow_data.resultFlag">
          <div class="">老人情况稳定，暂无需要特别关注的老人</div>
        </div>
      </div>
    </div>

    <!-- 状态优秀的老人 -->
    <div class="bjThing mt10" v-if="home_moon_foGood_data && home_moon_foGood_data.totleCount != 0">
      <div class="bjLeft heightAuto pb20" style="width:100%;">
        <div class="b_comTopCont">
          <div class="dayNum">最近30天</div>
          <div class="dayName">|</div>
          <div class="dayName">状态优秀的长者</div>
          <div class="countGreen">{{ home_moon_foGood_data.totleCount }}位</div>
          <div class="seeTh" @click="cli_see_gzOld_list_moon(2)">查看全部</div>
        </div>

        <!-- 有数据情况 -->
        <div class="bjContWrap bjContWrap_moon" v-show="home_moon_foGood_data.resultFlag">
          <div class="oldState">
            <!-- 一个 -->
            <div class="o_table border_no" v-if="home_moon_foGood_data.digitalTwinFollowCountList.length == 1">
              <div class="o_tableList border_4444" :key="index2" v-for="(item2,index2) in home_moon_foGood_data.digitalTwinFollowCountList">
                <div class="o_name">{{ item2.content }}</div>
                <div class="o_num">{{ item2.count }}位</div>
              </div>
            </div>
            <!-- 两个 -->
            <div class="o_table border_no" v-if="home_moon_foGood_data.digitalTwinFollowCountList.length == 2">
              <div class="o_tableList" :key="index2" v-for="(item2,index2) in home_moon_foGood_data.digitalTwinFollowCountList">
                <div class="o_name">{{ item2.content }}</div>
                <div class="o_num">{{ item2.count }}位</div>
              </div>
            </div>
            <!-- 三个或四个 -->
            <div class="o_table border_no o_table_Three" style="margin-top: 50px;" v-if="home_moon_foGood_data.digitalTwinFollowCountList.length > 2 && home_moon_foGood_data.digitalTwinFollowCountList.length < 5">
              <div class="o_tableList" :key="index2" v-for="(item2,index2) in home_moon_foGood_data.digitalTwinFollowCountList">
                <div class="o_name">{{ item2.content }}</div>
                <div class="o_num">{{ item2.count }}位</div>
              </div>
            </div>
            <!-- 五个或六个 -->
            <div class="o_table border_no o_table_Three" style="height: 262px;margin-top:3px;" v-if="home_moon_foGood_data.digitalTwinFollowCountList.length > 4">
              <div :key="index2" v-for="(item2,index2) in home_moon_foGood_data.digitalTwinFollowCountList">
                <div class="o_tableList" v-if="index2 < 5">
                  <div class="o_name">{{ item2.content }}</div>
                  <div class="o_num">{{ item2.count }}位</div>
                </div>
                <div class="o_tableList" v-if="index2 == 5">
                  <div class="o_name">...</div>
                  <div class="o_num">&nbsp;</div>
                </div>
              </div>
            </div>
            


            <div class="oRightWrap ml25">
              <el-carousel height="270px" :interval="50000" arrow="never" :loop="false" indicator-position='none'  ref="lb_moonFollow2" @change="change_lb_follow2">
                <el-carousel-item :key="index" v-for="(item,index) in home_moon_foGood_data.newList" >
                  <div class="oRightWrap" style="height: 270px;">
                    <div class="oRightList" :key="index2" v-for="(item2,index2) in item">
                      <div class="o_topBox">
                        <img class="peoIconImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                        <div class="oName">{{item2.buAndFlName}}</div>
                      </div>
                      <div class="flex mt10">
                        <div class="varSta varSta2">
                          <div>{{item2.contentList[0]}}</div>
                        </div>
                        <div class="exceIcon" v-if="item2.contentList.length > 2">
                          <div class="threePoint">...</div>
                        </div>
                      </div>
                      <div class="flex mt10" v-if="item2.contentList[1]">
                        <div class="varSta varSta2">
                          <div>{{item2.contentList[1]}}</div>
                        </div>
                      </div>
                      <div class="btnSee" @click="open_tan_needGz_portrait(item2)">查看</div>
                    </div>
                  </div>
                  
                </el-carousel-item>
              </el-carousel>
              <div v-if="home_moon_foGood_data.newList && home_moon_foGood_data.newList.length > 1">
                <img class="backIcon backIcon_left" src="../../../assets/backIconLeft.png" alt="" @click="arrowClick_follow(1,'good')" v-if="home_moon_foGood_lbPage != 1">
                <img class="backIcon backIcon_left" src="../../../assets/backIconLeft2.png" alt="" @click="arrowClick_follow(1,'good')" v-if="home_moon_foGood_lbPage == 1">
                <img class="backIcon backIcon_right" src="../../../assets/backIconRight.png" alt="" @click="arrowClick_follow(2,'good')" v-if="home_moon_foGood_lbPage != home_moon_foGood_data.newList.length">
                <img class="backIcon backIcon_right" src="../../../assets/backIconRight2.png" alt="" @click="arrowClick_follow(2,'good')" v-if="home_moon_foGood_lbPage == home_moon_foGood_data.newList.length">
              </div>

            </div>
          </div>
        </div>
        
        <!-- 无数据情况 -->
        <div class="noData" style="height:257px;" v-show="!home_moon_foGood_data.resultFlag">
          <div class="">老人情况稳定，暂无需要特别关注的老人</div>
        </div>
      </div>

      
    </div>




    <!-- 弹窗_需关注老人、优秀老人列表 -->
    <tan_needGz_list_moon ref="tan_needGz_list_moon"></tan_needGz_list_moon>

    <!-- 弹窗_数字画像 -->
    <tan_needGz_portrait ref="tan_needGz_portrait"></tan_needGz_portrait>

	<PortraitAlert ref="portraitAlert" />

    <!-- 弹窗_关注老人单人详情 -->
    <!-- <tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin> -->

  </div>
</template>

<script>
import tan_needGz_list_moon from './tan_needGz_list_moon.vue';      //弹窗_需关注老人、优秀老人列表
import tan_needGz_portrait from './tan_needGz_portrait.vue';        //弹窗_数字画像
import tan_needGz_sin from './tan_needGz_sin.vue';                  //弹窗_关注老人单人详情
import PortraitAlert from './portraitAlert.vue';        //弹窗_数字画像
export default {
  components: { tan_needGz_list_moon , tan_needGz_portrait,tan_needGz_sin, PortraitAlert },
  props: {
    healthBigData: null,
  },
  data() {
    return {
      myChart_Bar: null,
      myChart_Line: null,
      sleepChartPolice: null,

      
      home_moon_follow_data: null,    //首页_30天需关注数据
      home_moon_foGood_data: null,    //首页_30天状态优秀数据

      home_moon_follow_lbPage: 1,     // 首页_30天需关注轮播当前页数
      home_moon_foGood_lbPage: 1,     // 首页_30天需关注轮播当前页数
      

      
    };
  },
  created() {},
  mounted() {
    this.getHomeDigitalTwinFollowList();        //首页_查看最近30天需要关注老人
    this.getDigitalTwinFollowGoodTableList();   //首页_查看最近30天状态优秀的老人
  },
  methods: {
    // 首页_查看最近30天需要关注老人
    getHomeDigitalTwinFollowList(){
      let obj = {}
      this.$get(
        'api/v4/home/getHomeDigitalTwinFollowList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.home_moon_follow_data = res.data;

              // 此处注释放在了getDigitalTwinFollowPageList方法内
              // for(let i = 0;i < 2;i++){
              //   this.home_moon_follow_data.digitalTwinFollowCountList.push(this.home_moon_follow_data.digitalTwinFollowCountList[i])
              // }
              // for(let i = 0;i < 18;i++){
              //   this.home_moon_follow_data.needFollowPageListVoList.push(this.home_moon_follow_data.needFollowPageListVoList[i])
              // }
             

              // // 二维数组变一维数组start
              // let voList = res.data.needFollowPageListVoList
              // console.log(voList)
              // let len = voList.length;
              // let n = 8;
              // let num = len % 8 === 0 ? len / 8 : Math.floor((len / 8) + 1)  //得出多少份
              // let newList = []
              // for (let i = 0; i < num; i++) {
              //   // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
              //   const newArr = voList.slice(i * n, i * n + n) //得到每份的数据
              //   newList.push(newArr) //往res数组里加数据
              // }
              // console.log(newList, '二维数组')
              // this.home_moon_follow_data.newList = newList
              // // 二维数组变一维数组end


              // // 会用于弹窗列表内
              // this.tan_flagList_typeArr = []    //弹窗_报警列表_类别数组（早睡早起，睡得超安稳等）
              // for(let i = 0;i < this.home_moon_follow_data.digitalTwinFollowCountList.length;i++){
              //   this.home_moon_follow_data.digitalTwinFollowCountList[i].isSelect = true;
              //   this.tan_flagList_typeArr.push(this.home_moon_follow_data.digitalTwinFollowCountList[i].index)
              // }

              // 此处注释放在了getDigitalTwinFollowPageList方法内end


              this.getDigitalTwinFollowPageList()
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 首页_查看最近30天状态优秀的老人
    getDigitalTwinFollowGoodTableList(){
      let obj = {
        pageSize: 100
      }
      this.$get(
        'api/v4/home/getDigitalTwinFollowGoodTableList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.home_moon_foGood_data = res.data;

              // 此处注释放在了getDigitalTwinFollowGoodPageList方法内
              
              // // 二维数组变一维数组start
              // let voList = res.data.needFollowPageListVoList
              // console.log(voList)
              // let len = voList.length;
              // let n = 8;
              // let num = len % 8 === 0 ? len / 8 : Math.floor((len / 8) + 1)  //得出多少份
              // let newList = []
              // for (let i = 0; i < num; i++) {
              //   // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
              //   const newArr = voList.slice(i * n, i * n + n) //得到每份的数据
              //   newList.push(newArr) //往res数组里加数据
              // }
              // console.log(newList, '二维数组')
              // this.home_moon_foGood_data.newList = newList
              // // 二维数组变一维数组end

              
              // this.tan_flagList_typeArr2 = []    //弹窗_报警列表_类别数组（早睡早起，睡得超安稳等）
              // for(let i = 0;i < this.home_moon_foGood_data.digitalTwinFollowCountList.length;i++){
              //   this.home_moon_foGood_data.digitalTwinFollowCountList[i].isSelect = true;
              //   this.tan_flagList_typeArr2.push(this.home_moon_foGood_data.digitalTwinFollowCountList[i].index)
              // }

              // 此处注释放在了getDigitalTwinFollowGoodPageList方法内end

              this.$forceUpdate()
              this.getDigitalTwinFollowGoodPageList()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 首页_查看最近30天需要关注老人右侧全部数据
    getDigitalTwinFollowPageList(){
      console.log(this.tan_flagList_typeArr)
      let obj = {
        // flagList: this.tan_flagList_typeArr.toString(),
        pageNum: 1,
        pageSize: 1000,
        selectDateType: 30,    //取值:1, 7该参数不传默认为: 1
        sortField: 'ascend',
        sortOrder: 'ascend',     //顺序规则 正序-ascend，倒序-descend	
      }
      this.$get(
        'api/v4/home/getDigitalTwinFollowPageList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              
              // 二维数组变一维数组start
              let voList = res.data.records
              console.log(voList)
              let len = voList.length;
              let n = 8;
              let num = len % 8 === 0 ? len / 8 : Math.floor((len / 8) + 1)  //得出多少份
              let newList = []
              for (let i = 0; i < num; i++) {
                // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
                const newArr = voList.slice(i * n, i * n + n) //得到每份的数据
                newList.push(newArr) //往res数组里加数据
              }
              console.log(newList, '二维数组')
              this.home_moon_follow_data.newList = newList
              // 二维数组变一维数组end


              // 会用于弹窗列表内
              this.tan_flagList_typeArr = []    //弹窗_报警列表_类别数组（早睡早起，睡得超安稳等）
              for(let i = 0;i < this.home_moon_follow_data.digitalTwinFollowCountList.length;i++){
                this.home_moon_follow_data.digitalTwinFollowCountList[i].isSelect = true;
                this.tan_flagList_typeArr.push(this.home_moon_follow_data.digitalTwinFollowCountList[i].index)
              }
              
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 首页_查看最近30天状态优秀的老人右侧全部数据
    getDigitalTwinFollowGoodPageList(){
      let obj = {
        // flagList: this.tan_flagList_typeArr2.toString(),
        pageNum: 1,
        pageSize: 1000,
        selectDateType: 30,    //取值:1, 7该参数不传默认为: 1
        sortField: 'ascend',
        sortOrder: 'ascend',     //顺序规则 正序-ascend，倒序-descend	
      }
      this.$get(
        'api/v4/home/getDigitalTwinFollowGoodPageList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)


              // 二维数组变一维数组start
              let voList = res.data.records
              console.log(voList)
              let len = voList.length;
              let n = 8;
              let num = len % 8 === 0 ? len / 8 : Math.floor((len / 8) + 1)  //得出多少份
              let newList = []
              for (let i = 0; i < num; i++) {
                // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
                const newArr = voList.slice(i * n, i * n + n) //得到每份的数据
                newList.push(newArr) //往res数组里加数据
              }
              console.log(newList, '二维数组')
              this.home_moon_foGood_data.newList = newList
              // 二维数组变一维数组end

              
              this.tan_flagList_typeArr2 = []    //弹窗_报警列表_类别数组（早睡早起，睡得超安稳等）
              for(let i = 0;i < this.home_moon_foGood_data.digitalTwinFollowCountList.length;i++){
                this.home_moon_foGood_data.digitalTwinFollowCountList[i].isSelect = true;
                this.tan_flagList_typeArr2.push(this.home_moon_foGood_data.digitalTwinFollowCountList[i].index)
              }
              
              
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 首页_30天需关注点击轮播图按钮 type 左按钮1 右按钮2    whatType 需关注needGz 状态优秀good
    arrowClick_follow(type,whatType){
      if(whatType == 'needGz'){
        if(type == 1){
          this.$refs.lb_moonFollow.prev()
        }else {
          this.$refs.lb_moonFollow.next()
        }
      }else if(whatType == 'good'){
        if(type == 1){
          this.$refs.lb_moonFollow2.prev()
        }else {
          this.$refs.lb_moonFollow2.next()
        }
      }
    },
    // 首页_需关注老人_轮播切换时触发
    change_lb_follow(){
      let activeIndex = this.$refs.lb_moonFollow.activeIndex
      this.home_moon_follow_lbPage = Number(activeIndex + 1)
    },
    // 首页_需关注老人_轮播切换时触发
    change_lb_follow2(){
      let activeIndex = this.$refs.lb_moonFollow2.activeIndex
      this.home_moon_foGood_lbPage = Number(activeIndex + 1)
    },
    // 首页_点击关注老人三十天查看全部  type 需关注1  状态优秀2   
    cli_see_gzOld_list_moon(type){
      let data = {type: type}
      this.$refs.tan_needGz_list_moon.openComponent_tan_needGz_list_moon(data)
      
    },
    // 打开数字画像弹窗
    open_tan_needGz_portrait(data){
      this.$refs.tan_needGz_portrait.openComponent_tan_needGz_portrait(data)
    },
    
  },
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';


// 弹窗_需关注老人列表_三十天列表
.gaList_moonWrap{
  width: 100%;
  height: auto;
}

.noData{
  width: 100%;
  height: 100%;
  background: #F7F8FA;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #A5A9BC;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}





// 轮播图部分
.el-carousel{
  width: 874px !important;
  height: 270px !important;
  .el-carousel__item:nth-child(2n) {
    // background-color: #ccc;
  }
  .el-carousel__item:nth-child(2n+1) {
    // background-color: pink;
  }
}
</style>
